export const profileKeys = {
  updateProfile: "/user/profile",
  getLimits: "/user/limits",
  getTransactions: "/user/transactions",
  getProfile: "/user/profile",
  getBalance: "/user/balance",
  changePassword: "/user/password",
  getPaymentSystems: "/user/payments",
  createPayment: "/user/payments",
  createWithdraw: "/user/withdraw",
};
